"use client";

import { ExternalLink } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { LIMIT_REQUEST_FORM_URL } from "@/lib/limits-request";

interface LimitRequestDialogProps {
	/** Уточняющий текст (какой лимит исчерпан) вместо общего описания. */
	message?: string;
	onOpenChange: (open: boolean) => void;
	open: boolean;
}

/**
 * Модалка «лимит исчерпан» с переходом на форму заявки о расширении (t_df8944fa).
 *
 * Показывается владельцу аккаунта. Заполняющему форму её не показываем: он к
 * лимитам аккаунта отношения не имеет — там сработает письмо владельцу.
 */
export function LimitRequestDialog({
	open,
	onOpenChange,
	message,
}: LimitRequestDialogProps) {
	const t = useTranslations("limitsRequest");

	return (
		<Dialog onOpenChange={onOpenChange} open={open}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader className="flex flex-col gap-3">
					<DialogTitle>{t("title")}</DialogTitle>
					<DialogDescription className="text-left">
						{message || t("description")}
					</DialogDescription>
				</DialogHeader>
				<div className="flex flex-col gap-3">
					<Button asChild>
						<a
							href={LIMIT_REQUEST_FORM_URL}
							rel="noopener noreferrer"
							target="_blank"
						>
							{t("cta")}
							<ExternalLink aria-hidden="true" className="size-4" />
						</a>
					</Button>
					<Button onClick={() => onOpenChange(false)} variant="ghost">
						{t("close")}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
